<script setup lang="ts"></script>

<template>
  <h2
    class="font-pragmatica-ext mb-8 text-2xl font-bold sm:text-3xl lg:text-4xl"
  >
    <slot />
  </h2>
</template>
